import React from 'react';
import { useDeleteWebsiteIndexEntryMutation, useFetchWebsiteIndexEntriesQuery } from './service';
import { Alert, Button } from 'antd';
import useUrlState from '../../hooks/useUrlState';
import { useNavigate } from '../../router/hooks/useNavigate';

type Props = {
    websiteGuid: string;
    onFinish: () => void;
};

export default function DeleteWebsiteIndexEntry({ websiteGuid, onFinish }: Props) {
    const navigate = useNavigate();
    const setUrlState = useUrlState()[1];

    const [deleteWebsiteIndexEntry, { isLoading: isDeletingWebsiteIndexEntry }] = useDeleteWebsiteIndexEntryMutation();
    const { data: websiteIndexEntries, isLoading: isLoadingWebsiteIndexEntries } = useFetchWebsiteIndexEntriesQuery();

    const handleDeleteWebsite = async () => {
        try {
            await deleteWebsiteIndexEntry({ guid: websiteGuid }).unwrap();

            const newWebsiteIndexEntry = websiteIndexEntries?.find((website) => website.guid !== websiteGuid);

            // React throws a memory leak error if onFinish is called after setting url state
            onFinish();

            if (newWebsiteIndexEntry) {
                setUrlState({ w_guid: newWebsiteIndexEntry.guid });
            } else {
                navigate('/deep-analysis/setup-domain');
            }
        } catch (error) {}
    };

    return (
        <div className="deep-analysis-remove-website-index-form">
            <Alert
                className="remove-website-index-warning"
                message="Please note!"
                description={
                    <>
                        <div>By deleting this domain you will not be able to:</div>
                        <ul>
                            <li>Check your website for SEO problems</li>
                            <li>Access SEO audits for your website</li>
                            <li>Get suggestions and possible fixes</li>
                        </ul>
                    </>
                }
                type="error"
                showIcon
            />

            <Button
                className="remove-website-index-button"
                type="danger"
                size="small"
                loading={isDeletingWebsiteIndexEntry}
                disabled={isLoadingWebsiteIndexEntries}
                onClick={handleDeleteWebsite}
            >
                Remove
            </Button>
        </div>
    );
}
